import { z } from 'zod';

export const ConnectorStatusSchema = z.enum([
  'ACTIVATION_SUCCESS',
  'ACTIVATION_FAILURE',
  'DEACTIVATION_SUCCESS',
  'DEACTIVATION_FAILURE',
  'AWAITING_DELETION',
  'ACTIVATION_AWAITING',
  'DEACTIVATION_AWAITING',
]);

export const AdAccountStatusSchema = z.enum([
  'ACCOUNT_SUCCESS',
  'ACCOUNT_FAILURE',
  'ACCOUNT_DELETION_SUCCESS',
  'ACCOUNT_DELETION_FAILURE',
]);

const LocalAdAccountSchema = z.object({
  id: z.string(),
  name: z.string(),
  status: AdAccountStatusSchema,
  selected: z.boolean(),
  annotation: z.string().optional(),
});

export const ConnectorFromStoreSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: z.string(),
  category: z.enum(['advertising', 'user', 'session']),
  created_by: z.string(),
  status: ConnectorStatusSchema,
  last_modified_by: z.string(),
  isInitialSetup: z.boolean(),
  config: z.object({
    accounts: z.array(LocalAdAccountSchema),
  }),
  oauthId: z.string().nullable().optional(),
  timezone: z.string().optional(),
  locationCode: z.number().optional(),
  organizationId: z.string().optional(),
  connectorId: z.string().optional(),
});
